(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.faq');
    if (!section) return;

    var items = section.querySelectorAll('.faq__item');
    if (!items.length) return;

    // Mark section so CSS enables the height-based animation
    section.classList.add('faq--js');

    items.forEach(function (item) {
      var summary = item.querySelector('.faq__question');
      var answer  = item.querySelector('.faq__answer');
      if (!summary || !answer) return;

      // Set initial height for already-open items (e.g. editor preview)
      if (item.hasAttribute('open')) {
        answer.style.height = answer.scrollHeight + 'px';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (item.hasAttribute('open')) {
          // Close: animate from current height to 0
          answer.style.height = answer.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              answer.style.height = '0';
              answer.style.paddingBottom = '0';
            });
          });
          answer.addEventListener('transitionend', function onClose() {
            item.removeAttribute('open');
            answer.removeEventListener('transitionend', onClose);
          });
        } else {
          // Open: set [open] first so content is in the DOM, then animate
          item.setAttribute('open', '');
          var targetHeight = answer.scrollHeight;
          answer.style.height = '0';
          answer.style.paddingBottom = '0';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              answer.style.height = targetHeight + 'px';
              answer.style.paddingBottom = '';
            });
          });
          answer.addEventListener('transitionend', function onOpen() {
            answer.style.height = '';
            answer.removeEventListener('transitionend', onOpen);
          });
        }
      });
    });
  });
})();
